/* eslint-disable react/prop-types */
import { useEffect, useRef } from "react";
import nmp_mapboxgl from "@neshan-maps-platform/mapbox-gl";
import "@neshan-maps-platform/mapbox-gl/dist/NeshanMapboxGl.css";
import { Box } from "@mui/material";

export default function NeshanReportMap({ position, onChange, height = 380 }) {
    const containerRef = useRef(null);
    const mapRef = useRef(null);
    const markerRef = useRef(null);
    const onChangeRef = useRef(onChange);

    useEffect(() => {
        onChangeRef.current = onChange;
    }, [onChange]);

    useEffect(() => {
        if (!containerRef.current || mapRef.current) return;

        const defaultPosition = {
            lat: 36.290434,
            long: 59.539085,
        };

        const initialPosition = position || defaultPosition;

        const map = new nmp_mapboxgl.Map({
            container: containerRef.current,
            mapKey: "web.c513a1143a9b4859a897f04e9e95b926",
            mapType: "neshanRaster",
            traffic: false,
            zoom: position ? 13 : 11,
            center: [Number(initialPosition.long), Number(initialPosition.lat)],
            mapTypeControllerOptions: { show: false },
        });

        mapRef.current = map;

        map.on("click", (e) => {
            onChangeRef.current({
                lat: e.lngLat.lat,
                long: e.lngLat.lng,
            });
        });

        return () => {
            if (markerRef.current) {
                markerRef.current.remove();
                markerRef.current = null;
            }

            map.remove();
            mapRef.current = null;
        };
    }, []);

    useEffect(() => {
        const map = mapRef.current;

        if (!map || !position?.lat || !position?.long) return;

        const lngLat = [Number(position.long), Number(position.lat)];

        if (markerRef.current) {
            markerRef.current.remove();
        }

        const popup = new nmp_mapboxgl.Popup({ offset: 25 }).setHTML(`
            <div style="direction: rtl; text-align: right; font-family: sans-serif; font-size: 12px; color: #111827;">
                <strong>نقطه انتخاب‌شده</strong>
                <br />
                <span>Lat: ${Number(position.lat).toFixed(6)}</span>
                <br />
                <span>Long: ${Number(position.long).toFixed(6)}</span>
            </div>
        `);

        markerRef.current = new nmp_mapboxgl.Marker({ color: "#0284c7" })
            .setLngLat(lngLat)
            .setPopup(popup)
            .addTo(map);

        map.flyTo({
            center: lngLat,
            zoom: 14,
            duration: 700,
        });
    }, [position?.lat, position?.long]);

    return (
        <Box
            sx={{
                width: "100%",
                height,
                borderRadius: 3.5,
                overflow: "hidden",
                border: "1px solid rgba(226,232,240,0.95)",
                boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.4)",
            }}
        >
            <div
                ref={containerRef}
                style={{
                    width: "100%",
                    height: "100%",
                }}
            />
        </Box>
    );
}